<div class="page-not-found-container">
  <h1>404</h1>
  <p>Oops! The page you're looking for doesn't exist.</p>
  <button (click)="navigateToHome()">Go to Home</button>
</div>
